<template>
  <share-button :entity-type="entityType" :entity-slug="entitySlug" :channel-settings="channelSettings"
                :utm-medium="utmMedium" :share-url-from-url="shareUrlFromUrl" />
</template>

<script>
import ButtonMixin from './button-mixin'

export default {
  mixins: [ButtonMixin],

  methods: {
    shareTextFromUrl(url) {
      const orgBlueskyHandle = this.channelSettings.orgHandle
      if (orgBlueskyHandle) {
        return `${url} @${this.channelSettings.orgHandle}`
      } else {
        return url
      }
    },

    shareUrlFromUrl(url) {
      const shareText = this.shareTextFromUrl(url)
      const params = new URLSearchParams({text: shareText})

      return `https://bsky.app/intent/compose?${params.toString()}`
    }
  }
}
</script>
